import { SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
// taken from @see https://www.youtube.com/watch?v=-VJTh7OqoJI
// @see https://github.com/leighhalliday/maps-demo-clustering
// Temporary fix for https://github.com/googlemaps/js-markerclusterer/pull/419
export default class BoundingSuperClusterAlgorithm extends SuperClusterAlgorithm {
  cluster({ map }) {
    const bounds = map.getBounds().toJSON();
    const boundingBox = [bounds.west, bounds.south, bounds.east, bounds.north];

    return this.superCluster
      .getClusters(boundingBox, Math.round(map.getZoom()))
      .map(this.transformCluster.bind(this));
  }
}
